import React from 'react';

import { IonIcon } from '@ionic/react';
import { checkmarkOutline, closeOutline } from 'ionicons/icons';

import { IActionStatus } from './interfaces';

const APPROVED = 2;
const REJECTED = 3;

const ActionStatus: React.FC<IActionStatus> = ({ actionId }) => {
  if (actionId === APPROVED) {
    return <IonIcon icon={checkmarkOutline} color={'success'} />;
  }

  if (actionId === REJECTED) {
    return <IonIcon icon={closeOutline} color={'danger'} />;
  }

  return null;
};

export default ActionStatus;
